import { TAnalyticEventParams } from '@/_analytic/_types';

type TProps = {
  categoryName: string;
  isRecommended: boolean;
};
export const getSectionName = ({
  categoryName,
  isRecommended,
}: TProps): TAnalyticEventParams['subsectionName'] => {
  if (isRecommended) {
    return 'by_recommend';
  }
  if (!categoryName) {
    return 'by_link';
  }

  return categoryName || null;
};
